import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconNotes(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 13L15 1H1L1 15C1 16.1046 1.89543 17 3 17C4.10457 17 5 16.1046 5 15V13H15Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M4 5H12" stroke="currentColor" strokeWidth="2" />
      <path d="M4 8H12" stroke="currentColor" strokeWidth="2" />
      <path
        d="M15 17C16.1046 17 17 16.1046 17 15V13H5V15C5 16.1046 4.10457 17 3 17H15Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
      />
      <rect x="5" y="11" width="6" height="2" fill="currentColor" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
